import { get } from 'shared/util/helpers';
import { logError } from 'client/javascript/util/logger';

const shouldShowPromoTagForCountry = (countryCode, promoTag) => {
  const countryWhitelist = get(promoTag, 'dataset.countryWhitelist', '').split(',');
  return countryWhitelist.includes(countryCode);
};

export const showGeocodedPromoTags = (countryCode, promoTagSelector = '.card-product__promo') => {
  document.querySelectorAll(promoTagSelector).forEach((promoTag) => {
    if (shouldShowPromoTagForCountry(countryCode, promoTag)) {
      promoTag.classList.remove('hidden');
    }
  });
};

export const setupCardProductModule = (countryCode) => {
  try {
    showGeocodedPromoTags(countryCode);
  } catch (error) {
    logError(`[Card Product] setupCardProductModule failed: ${error.message}`, error);
  }
};
